import { BACKEND_URL } from '../api/axiosClient';

export const getImageUrl = (path) => {
  if (!path) return null;

  if (path.startsWith('http')) return path;
  if (path.startsWith('/storage')) return `${BACKEND_URL}${path}`;
  if (path.startsWith('storage/')) return `${BACKEND_URL}/${path}`;

  return `${BACKEND_URL}/storage/${path}`;
};

export const formatDate = (dateString) => {
  if (!dateString) return '—';

  try {
    return new Date(dateString).toLocaleDateString('fr-FR');
  } catch {
    return dateString;
  }
};

export const getUserName = (branding) => {
  const user = branding.user;

  if (!user) return 'Utilisateur inconnu';

  const prenom = user.prenom || '';
  const nom = user.nom || '';

  return `${prenom} ${nom}`.trim() || 'Utilisateur inconnu';
};

export const getCampaignName = (branding) => {
  return branding.nomCampagne || 'Campagne non définie';
};

export const getPhotosByType = (branding, type) => {
  const photos = Array.isArray(branding.photos) ? branding.photos : [];

  const typedPhotos = photos
    .filter((photo) => photo.type === type && photo.path)
    .map((photo, index) => ({
      id: photo.id || `${type}-${branding.id}-${index}`,
      path: photo.path,
      type: photo.type,
    }));

  if (typedPhotos.length > 0) {
    return typedPhotos;
  }

  if (type === 'before' && branding.photo_before) {
    return [
      {
        id: `old-before-${branding.id}`,
        path: branding.photo_before,
        type: 'before',
      },
    ];
  }

  if (type === 'after' && branding.photo_after) {
    return [
      {
        id: `old-after-${branding.id}`,
        path: branding.photo_after,
        type: 'after',
      },
    ];
  }

  return [];
};

export const getFacadePhotos = (branding) => {
  return getPhotosByType(branding, 'facade');
};

export const getBeforePhotos = (branding) => {
  return getPhotosByType(branding, 'before');
};

export const getAfterPhotos = (branding) => {
  return getPhotosByType(branding, 'after');
};

export const getAllPhotos = (branding) => {
  const facadePhotos = getFacadePhotos(branding).map((photo) => ({
    ...photo,
    typeLabel: 'facade',
  }));

  const beforePhotos = getBeforePhotos(branding).map((photo) => ({
    ...photo,
    typeLabel: 'avant',
  }));

  const afterPhotos = getAfterPhotos(branding).map((photo) => ({
    ...photo,
    typeLabel: 'apres',
  }));

  return [...facadePhotos, ...beforePhotos, ...afterPhotos];
};

export const sanitizeFileName = (value) => {
  return String(value || 'branding')
    .replace(/\s+/g, '_')
    .replace(/[^a-zA-Z0-9_-]/g, '');
};

export const getImageExtension = (url) => {
  if (!url) return 'jpg';

  const cleanUrl = url.split('?')[0];
  const extension = cleanUrl.split('.').pop();

  if (!extension || extension.length > 5) {
    return 'jpg';
  }

  return extension;
};